import Medalla from './medalla';

export default function Victoria({ nombre, color, today, fraseSeleccionada, secondsElapsed, medalla, media, porcentajeSuperado, clickContinuar, icono, idJuego}:
                                {nombre: any; color:any; today:any; fraseSeleccionada:any; secondsElapsed:any; medalla:any;
                                  media:any; porcentajeSuperado:any; clickContinuar:any; icono:any; idJuego:any;}) {

const formatClock = (totalSeconds: number): string => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = Math.round(totalSeconds % 60);
  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};

return (
    <div className="victory-message">
      <div className="content">
        <img src={"./"+icono} alt={nombre} className="game-logo" />
        <span className="fecha">{today}</span>
        <Medalla num={medalla}></Medalla>
        <p className="frase">{fraseSeleccionada}</p>

        <div className="stats">
          <div className="stat">
            <img src="./velocidad.png" alt="Velocidad" />
            <p>Has tardado<br/><strong>{secondsElapsed}</strong></p>
          </div>
          <div className="stat">
            <img src="./media.png" alt="Media" />
            <p>Tiempo medio<br/><strong>{formatClock(media)}</strong></p>
          </div>
          <div className="stat">
            <img src="./porcentaje.png" alt="Porcentaje" />
            <p>Has superado al<br/><strong>{porcentajeSuperado.toFixed(2)}%</strong></p>
          </div>
        </div>

        <p className="victory-puzztime">Vuelve mañana para seguir jugando</p>
      </div>
    </div>
    )
}
